export const MessageType = {
  AUTHENTICATE: 'AUTHENTICATE',
  AUTHENTICATION_DONE: 'AUTHENTICATION_DONE',
  INCREMENT_UI_REQUEST: 'INCREMENT_UI_REQUEST',
  QUERY_CREATED: 'QUERY_CREATED',
  QUERY_UPDATED: 'QUERY_UPDATED',
};
